export const errorCodes = {
  ABONMAN_YUKLENEMEZ: '738',
  BU_AY_ABONMAN_YUKLENEMEZ: '736',
};
